export enum DashboardActiveStep {
  Account = "Account",
  Clubs = "Clubs",
  Treasuries = "Treasuries",
  Deposits = "Deposits",
  Proposals = "Proposals",
  Withdrawals = "Withdrawals",
  Staking = "Staking",
  Invitations = "Invitations",
  Applications = "Applications",
  Dashboard = "Overview",
}

export enum DashboardItemType {
  Clubs,
  Deposits,
  TotalWithdraw,
  AvailalbeWithdraw,
  ActiveProposals,
  Invitations,
  StakedAmount,
  Reward,
}

export enum DashboardFilter {
  Role = "role",
  StakingStatus = "stakingStatus",
  WithdrawalClaimed = "hasWithdrawn",
  FundingStatus = "isFundraisingInProgress",
}
